export default __webpack_public_path__ + "static/media/Armguards of the Invincible.b633361b.jpg";